export default "__VITE_ASSET__DSs0BlCm__"